import React, { useState } from "react";
import { Field, FieldArray, Form, Formik } from "formik";
import Papa from "papaparse";
import Button from "../form-components/Button";
import addcircleimg from "../../assets/images/add-circle.svg";
import minuscircleimg from "../../assets/images/minus-circle.svg";
import { useDispatch, useSelector } from "react-redux";
import {
  fetchCrawlledUrls,
  resetCrawlledUrlList,
} from "../../features/user-document/fetchCrawlUrls";
import trashImg from "../../assets/images/trash.svg";
import Input from "../form-components/Input";
import { crawlDocument } from "../../features/user-document/crawlDocumentsSlice";
import { OK } from "../../constants/statusCode";
import { getDocuments } from "../../features/user-document/documentListingSlice";
import { showError } from "../../utils/messageHelper";
// import crawlSinglePadeValidationSchema from '../../validations/documentValidation/crawlSinglePadeValidationSchema';

function countTotalDuplicates(arr, type) {
  const uniqueUrls = new Set();
  var duplicateCount = 0;

  arr.forEach((url) => {
    if (uniqueUrls.has(url.link || url.value)) {
      // URL is a duplicate
      duplicateCount++;
    } else {
      uniqueUrls.add(url.link || url.value);
    }
  });
  return duplicateCount;
}

const CrawlComponent = ({ toggle, setSubCategories }) => {
  const { isLoading, apiFetchedUrls, isCrallingLoading } = useSelector(
    (state) => ({
      apiFetchedUrls: state?.fetchCrawlledUrlReducer?.responseData,
      isLoading: state?.fetchCrawlledUrlReducer?.isLoading,
      isCrallingLoading: state?.crawlDocumentReducer?.isLoading,
    })
  );

  const [selectedType, setSelectedType] = useState("singlePage");
  const [link, setLink] = useState("");
  const [isError, setIsError] = useState(false);
  const [fetchedUrls, setFetchedUrls] = useState([]);
  const [originalData, setOriginalData] = useState([]);
  const [searchValue, setSearchValue] = useState("");
  let projectData = JSON.parse(localStorage.getItem("_user"));
  const dispatch = useDispatch();

  const fetchUrls = async () => {
    setFetchedUrls([]);
    let formData = {};
    formData.sitemap_url = link;
    formData.type = selectedType === "rssfeed" ? "rss" : "sitemap";
    const { payload } = await dispatch(fetchCrawlledUrls(formData));
    let arr = payload?.data?.data?.links?.map((d, idx) => ({
      id: idx,
      value: d,
    }));
    setFetchedUrls(arr);
    setOriginalData(arr);
    setSearchValue("");
  };

  const onDeleteClick = (i) => {
    const data = originalData.filter((data, index) => data?.id !== i);
    const newData = data.filter((data) => data?.value.includes(searchValue));
    setFetchedUrls(newData);
    setOriginalData(data);
  };

  const onSearchChange = (e) => {
    setSearchValue(e.target.value);
    const data = originalData.filter((data) =>
      data?.value.includes(e.target.value)
    );
    setFetchedUrls(data);
  };

  const clearSearch = () => {
    setSearchValue("");

    setFetchedUrls(originalData);
  };

  const onRadioChange = (e) => {
    setSelectedType(e.target.value);
    setLink("");
    setIsError(false);
    setSearchValue("");
    setFetchedUrls([]);
    dispatch(resetCrawlledUrlList());
  };

  const handleFileUpload = (event, setFieldValue) => {
    const file = event.target.files[0];
    Papa.parse(file, {
      // header: true,
      dynamicTyping: true,
      complete: (results) => {
        const singlePageLink = [];
        results.data.forEach((row) => {
          Object.values(row).forEach((value) => {
            if (typeof value === "string") {
              const match = value.match(/\b(http|https)?:\/\/\S+\b/);
              if (match) {
                singlePageLink.push({ link: match[0] });
              }
            }
          });
        });
        if (singlePageLink.length > 0) {
          setIsError(false);
          setFieldValue("singlePageLink", singlePageLink);
        } else {
          setIsError(true);
          setFieldValue("singlePageLink", [{ link: "" }]);
        }
      },
    });
  };

  const onCrawlSinglePageClick = async (values) => {
    if (values?.singlePageLink[0].link) {
      let formData = {};
      formData.project_uuid = projectData?.projects[0]?.uuid;
      let finalArray = values.singlePageLink.map(
        (d) => typeof d.link !== "function" && d.link
      );
      formData.document_url = finalArray.filter((d) => d !== false);
      formData.source_type = "single_page";
      const { payload } = await dispatch(crawlDocument(formData));
      if (payload.status === OK) {
        setSubCategories("Documents");
        dispatch(
          getDocuments({
            perPage: 10,
            page: 1,
            project_uuid: projectData?.projects[0]?.uuid,
          })
        );
        toggle();
      } else {
        showError("Something went wrong!");
      }
    }
  };

  const onCrawlClick = async () => {
    if (link) {
      let formData = {};
      formData.project_uuid = projectData?.projects[0]?.uuid;
      const extractedUrls = fetchedUrls.map((item) => item.value);
      formData.document_url = extractedUrls;
      if (selectedType === "websitemap") {
        formData.source_type = "sitemap";
      } else if (selectedType === "rssfeed") {
        formData.source_type = "rss_feed";
      }
      const { payload } = await dispatch(crawlDocument(formData));
      if (payload.status === OK) {
        setSubCategories("Documents");
        dispatch(
          getDocuments({
            perPage: 10,
            page: 1,
            project_uuid: projectData?.projects[0]?.uuid,
          })
        );
        toggle();
      } else {
        showError("Something went wrong!");
      }
    }
  };

  return (
    <>
      <h4>Web Crawler</h4>
      <div className="radio-crwl-grp">
        <div className="radio-radiodiv">
          <Input
            type="radio"
            id="singlePage"
            name="fav_language"
            className="form-check-input"
            onChange={(e) => onRadioChange(e)}
            checked={selectedType === "singlePage"}
            value="singlePage"
          />
          <label className="form-label" htmlFor="singlePage">
            Single Page
          </label>
        </div>
        <div className="radio-radiodiv">
          <Input
            type="radio"
            id="websitemap"
            name="fav_language"
            className="form-check-input"
            onChange={(e) => onRadioChange(e)}
            checked={selectedType === "websitemap"}
            value="websitemap"
          />
          <label className="form-label" htmlFor="websitemap">
            Web Sitemap
          </label>
        </div>
        <div className="radio-radiodiv">
          <Input
            type="radio"
            id="rssfeed"
            name="fav_language"
            className="form-check-input"
            onChange={(e) => onRadioChange(e)}
            checked={selectedType === "rssfeed"}
            value="rssfeed"
          />
          <label className="form-label" htmlFor="rssfeed">
            Rss Feed
          </label>
        </div>
      </div>
      {selectedType === "singlePage" && (
        <div className="d-flex flex-column h-100">
          <>
            <p className="rad-para">
              To construct your unique GPT chatbot, Provide us with your Web
              URL.
            </p>
            <div className="form-group d-flex h-100">
              <Formik
                className="d-flex flex-column h-100"
                initialValues={{
                  singlePageLink: [{ link: "" }],
                }}
                // validationSchema={crawlSinglePadeValidationSchema}
                onSubmit={onCrawlSinglePageClick}
              >
                {({
                  values,
                  handleChange,
                  handleBlur,
                  touched,
                  isSubmitting,
                  errors,
                  handleSubmit,
                  setFieldValue,
                }) => (
                  <Form className="d-flex flex-column h-100">
                    <FieldArray name="singlePageLink">
                      {({ remove, push }) => (
                        <>
                          <h5 className="rad-txt">
                          
                            Add web links you want to crawl or
                            <a className="rad-link">
                              <input
                                type="file"
                                accept=".csv, application/vnd.ms-excel, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
                                className="cursor-pointer rad-link-input"
                                onChange={(e) => {
                                  handleFileUpload(e, setFieldValue);
                                }}
                              />
                              import csv
                            </a>
                            .
                            {values?.singlePageLink.length > 0 &&
                              values?.singlePageLink[0].link !== "" && (
                                <div className="mt-2">
                                  Total Links: {values?.singlePageLink?.length}{" "}
                                  Duplicate Links:{" "}
                                  {countTotalDuplicates(
                                    values?.singlePageLink,
                                    "single page"
                                  )}
                                </div>
                              )}
                          </h5>
                          <div className="single-page-height">
                            {values?.singlePageLink.map((d, i) => {
                              return (
                                <div className="d-flex mymargin-bottom" key={i}>
                                  <Field
                                    type="text"
                                    name={`singlePageLink.${i}.link`}
                                    className="form-control"
                                    placeholder="Add link here"
                                    value={values.singlePageLink[i]?.link}
                                    // errors={errors}
                                    // touched={touched}
                                    onChange={(e) =>
                                      setFieldValue(
                                        `singlePageLink.${i}.link`,
                                        e.target.value
                                      )
                                    }
                                  />
                                  {i + 1 !== values?.singlePageLink.length && (
                                    <Button
                                      type="button"
                                      className="btn"
                                      onClick={() => remove(i)}
                                    >
                                      <img src={minuscircleimg} />
                                    </Button>
                                  )}
                                  {i + 1 === values?.singlePageLink.length && (
                                    <Button
                                      type="button"
                                      className="btn"
                                      onClick={() =>
                                        values?.singlePageLink[
                                          values?.singlePageLink.length - 1
                                        ].link !== "" &&
                                        values?.singlePageLink[
                                          values?.singlePageLink.length - 1
                                        ] !== "" &&
                                        push("")
                                      }
                                    >
                                      <img src={addcircleimg} />
                                    </Button>
                                  )}
                                </div>
                              );
                            })}
                          </div>
                          {isError && (
                            <p className="text-danger mb-3">
                              There are no links in your uploaded CSV please
                              upload another one.
                            </p>
                          )}
                        </>
                      )}
                    </FieldArray>
                    <p className="rad-para uni-black-col">
                      To construct your unique GPT chatbot, Provide us with your
                      Web URL in the same manner. We will detect and utilize all
                      of the pages within it to create your chatbot.
                    </p>
                    <div className="text-end mt-auto modal-footer pb-0 pt-3 pe-0">
                      <Button
                        disabled={
                          isCrallingLoading ||
                          values?.singlePageLink?.length <= 0
                        }
                        className="btn btn-primary-md"
                        onClick={handleSubmit}
                      >
                        {isCrallingLoading ? (
                          <i className="fa fa-spinner fa-spin"></i>
                        ) : (
                          "Crawl"
                        )}
                      </Button>
                    </div>
                  </Form>
                )}
              </Formik>
            </div>
          </>
        </div>
      )}
      {selectedType === "websitemap" && (
        <>
          <p className="rad-para">
            Submit a website's sitemap xml to build a custom chatbot from its
            pages. This works for any website, whether it's yours, a
            competitor's, or one you're curious about.
          </p>
          <h5 className="rad-txt">
            Add web sitemap you want to crawl
            {fetchedUrls && fetchedUrls.length > 0 && (
              <div className="mt-2">
                Total Links: {fetchedUrls.length} Duplicate Links:{" "}
                {countTotalDuplicates(fetchedUrls, "site map")}
              </div>
            )}
          </h5>

          <div className="form-group d-flex">
            <Input
              type="text"
              className="form-control"
              placeholder="Add link here"
              value={link}
              onChange={(e) => setLink(e.target.value)}
            />
            <Button
              type="button"
              className="btn create-doc-btn create-doc-btn-margin mt-0 ms-3 ps-3 fetch-btn"
              onClick={() => fetchUrls()}
              disabled={isLoading || link === ""}
            >
              {isLoading ? <i className="fa fa-spinner fa-spin"></i> : "Fetch"}
            </Button>
          </div>
          <p className="rad-para uni-black-col">
            To construct your unique GPT chatbot, provide us with your XML
            sitemap in the same manner as you would for Google Search Console.
            We will detect and utilize all of the pages within it to create your
            chatbot.
          </p>
          {apiFetchedUrls?.length > 0 && (
            <div className="intro-searchbar mb-3">
              <Button
                disabled
                type="button"
                className="filter-search-btn"
              ></Button>
              <Input
                type="text"
                onChange={(e) => onSearchChange(e)}
                value={searchValue}
                className="form-control"
                name="search"
                placeholder="search"
              />
              {searchValue.length > 0 && (
                <button
                  type="button"
                  class="btn search-reset-btn"
                  onClick={() => {
                    clearSearch();
                  }}
                >
                  <svg
                    class="close-icon"
                    xmlns="http://www.w3.org/2000/svg"
                    width="13.414"
                    height="13.414"
                    viewBox="0 0 13.414 13.414"
                  >
                    <g
                      id="Group_31758"
                      data-name="Group 31758"
                      transform="translate(0.707 0.707)"
                    >
                      <path
                        id="Path_48155"
                        data-name="Path 48155"
                        d="M0,0,12,12"
                        fill="none"
                        stroke="#313b5c"
                        stroke-width="2"
                      ></path>
                      <path
                        id="Path_48154"
                        data-name="Path 48154"
                        d="M12,0,0,12"
                        fill="none"
                        stroke="#313b5c"
                        stroke-width="2"
                      ></path>
                    </g>
                  </svg>
                </button>
              )}
            </div>
          )}
          <div className="fetch-url-main">
            {fetchedUrls?.length > 0
              ? fetchedUrls?.map((url, i) => {
                  return (
                    <div
                      className="d-flex justify-content-between fetch-url-dv"
                      key={i}
                    >
                      <p>{url?.value}</p>
                      <img
                        src={trashImg}
                        onClick={() => onDeleteClick(url?.id)}
                      />
                    </div>
                  );
                })
              : apiFetchedUrls?.length > 0 && (
                  <p className="d-flex justify-content-center">No Urls found</p>
                )}
          </div>
        </>
      )}
      {selectedType === "rssfeed" && (
        <>
          <p className="rad-para ">
            Submit a RSS Feed URL to build a custom chatbot from its pages. This
            works for any website, whether it's yours, a competitor's, or one
            you're curious about.
          </p>
          <h5 className="rad-txt">
            Add RSS URL you want to crawl
            {fetchedUrls && fetchedUrls.length > 0 && (
              <div className="mt-2">
                Total Links: {fetchedUrls.length} Duplicate Links:{" "}
                {countTotalDuplicates(fetchedUrls, "site map")}
              </div>
            )}
          </h5>
          <div className="form-group d-flex">
            <Input
              type="text"
              className="form-control"
              placeholder="Add link here"
              value={link}
              onChange={(e) => setLink(e.target.value)}
            />
            <Button
              type="button"
              className="btn create-doc-btn create-doc-btn-margin mt-0 ms-3 ps-3 fetch-btn"
              onClick={() => fetchUrls()}
              disabled={isLoading || link === ""}
            >
              {isLoading ? <i className="fa fa-spinner fa-spin"></i> : "Fetch"}
            </Button>
          </div>
          <p className="rad-para uni-black-col">
            To construct your unique GPT chatbot, provide us with your RSS URL
            in the same manner as you would for Google Search Console. We will
            detect and utilize all of the pages within it to create your
            chatbot.
          </p>
          {apiFetchedUrls?.length > 0 && (
            <div className="intro-searchbar mb-3">
              <Button
                disabled
                type="button"
                className="filter-search-btn"
              ></Button>
              <Input
                type="text"
                onChange={(e) => onSearchChange(e)}
                value={searchValue}
                className="form-control"
                name="search"
                placeholder="Search"
              />
              {searchValue.length > 0 && (
                <button
                  type="button"
                  class="btn search-reset-btn"
                  onClick={() => {
                    clearSearch();
                  }}
                >
                  <svg
                    class="close-icon"
                    xmlns="http://www.w3.org/2000/svg"
                    width="13.414"
                    height="13.414"
                    viewBox="0 0 13.414 13.414"
                  >
                    <g
                      id="Group_31758"
                      data-name="Group 31758"
                      transform="translate(0.707 0.707)"
                    >
                      <path
                        id="Path_48155"
                        data-name="Path 48155"
                        d="M0,0,12,12"
                        fill="none"
                        stroke="#313b5c"
                        stroke-width="2"
                      ></path>
                      <path
                        id="Path_48154"
                        data-name="Path 48154"
                        d="M12,0,0,12"
                        fill="none"
                        stroke="#313b5c"
                        stroke-width="2"
                      ></path>
                    </g>
                  </svg>
                </button>
              )}
            </div>
          )}
          <div className="fetch-url-main">
            {fetchedUrls?.length > 0
              ? fetchedUrls?.map((url, i) => {
                  return (
                    <div
                      className="d-flex justify-content-between fetch-url-dv"
                      key={i}
                    >
                      <p>{url?.value}</p>
                      <img
                        src={trashImg}
                        onClick={() => onDeleteClick(url?.id)}
                      />
                    </div>
                  );
                })
              : apiFetchedUrls?.length > 0 && (
                  <p className="d-flex justify-content-center">No Urls found</p>
                )}
          </div>
        </>
      )}
      {selectedType !== "singlePage" && (
        <div className="text-end mt-auto modal-footer pb-0 pt-3 pe-0">
          <Button
            disabled={isCrallingLoading}
            className="btn btn-primary-md"
            onClick={onCrawlClick}
          >
            {isCrallingLoading ? (
              <i className="fa fa-spinner fa-spin"></i>
            ) : (
              "Crawl"
            )}
          </Button>
        </div>
      )}
    </>
  );
};

export default CrawlComponent;
